import React from "react";
import {connect} from "react-redux";
import ClerkBiddersListTabContentCmp from "./ClerkBiddersListTabContentCmp";
import ClerkChatTabContentCmp from "./ClerkChatTabContentCmp";
import {TaggedLogger} from "@nextlot/core/utilities";
import {AuctionsManager} from "@nextlot/core/webcast";
import {ReduxStateType} from "@nextlot/core/webcast/services/DataStore";

const TAB_CHAT = 'tab_chat';
const TAB_BIDDERS = 'tab_bidders';



type RootCmpPropsType = {
    participants: {
        onlineBidders: [],
        offlineBidders: [],
        onlineViewers: [],
        offlineViewers: [],
    }
};


type CmpStateType = {
    activeTab:string,
};


const _logger = TaggedLogger.get('ClerkBiddersListAndChatRootCmp');


class ClerkBiddersListAndChatRootCmp extends React.Component<RootCmpPropsType, CmpStateType> {


    constructor(props) {
        super(props);

        this.state = {
            activeTab: TAB_CHAT,
        }
    }




    isActiveTabEqualTo = (tabId) => {
        return (this.state.activeTab === tabId)
    };



    handleTabClick = (tabId) => (evt) => {
        evt.preventDefault();

        if (this.isActiveTabEqualTo(tabId)) {
            return
        }

        this.setState({
            activeTab: tabId
        });
    };


    handleOpenChatRoom = (roomId:number) => {
        this.setState({
            activeTab: TAB_CHAT,
        }, () => {
            AuctionsManager.currentWebcastAuctionHandler.controller.openChatRoomAndMarkAsRead(roomId);
        });
    };

    handleCloseChatRoom = (roomId:number) => {
        AuctionsManager.currentWebcastAuctionHandler.controller.closeChatRoom(roomId);
    };



    render() {
        return (
            <div className='clerk-bidders-and-chat-tabbed-container'>

                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a className={`nav-link ${this.isActiveTabEqualTo(TAB_CHAT) ? 'active' : ''}`} onClick={this.handleTabClick(TAB_CHAT)} href="#">
                            Chat
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className={`nav-link ${this.isActiveTabEqualTo(TAB_BIDDERS) ? 'active' : ''}`} onClick={this.handleTabClick(TAB_BIDDERS)} href="#">
                            Bidders ({this.props.participants.onlineBidders.length}/{this.props.participants.onlineBidders.length + this.props.participants.offlineBidders.length})
                        </a>
                    </li>
                </ul>

                <div className="tab-content">
                    {
                        this.isActiveTabEqualTo(TAB_CHAT) ?

                            <ClerkChatTabContentCmp
                                openChatRoom={this.handleOpenChatRoom}
                                closeChatRoom={this.handleCloseChatRoom}
                            />

                            :

                            <ClerkBiddersListTabContentCmp
                                participants={this.props.participants}
                                openChatRoom={this.handleOpenChatRoom}
                            />

                    }
                </div>

            </div>
        );
    }
}


export default connect(({ activeWebcast }:ReduxStateType) => {
    return {
        participants: activeWebcast.webcastParticipants
    };
})(ClerkBiddersListAndChatRootCmp);


